import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { TextInput } from "../../../../components/inputs";
import BreadCrumb from '../../../common/breadcrumb/breadCrumb';
import { postData } from "../../../../../core/services/api";
import SuccessModal from "../../../../components/modal/SuccessModal";
import ErrorModal from "../../../../components/modal/ErrorModal";
import { extractEmail } from "../../../../../core/utils/utils";

const ComplaintUserEmail = () => {
  const location = useLocation();
  const complaintData = location.state;

  const isValidEmail = (email: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const initialEmail = extractEmail(complaintData?.phoneOrEmail || '');

  const [userEmail, setUserEmail] = useState<string>(initialEmail);
  const [submitting, setSubmitting] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!complaintData?.id) {
      setErrorMessage("No se encontró el ID del reclamo.");
      setErrorModalVisible(true);
      return;
    }

    if (!isValidEmail(userEmail)) {
      setErrorMessage("Por favor ingresa un correo electrónico válido.");
      setErrorModalVisible(true);
      return;
    }

    try {
      setSubmitting(true);
      const endpoint = `complaints/${complaintData.id}/send-email?email=${userEmail}`;
      await postData(endpoint, {});
      setSuccessModalVisible(true);
    } catch (err) {
      console.error("Error al enviar el correo:", err);
      setErrorMessage("Ocurrió un error al enviar el correo. Intenta nuevamente.");
      setErrorModalVisible(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <BreadCrumb title="Envio de Libro de Reclamaciones" item1="Home" item2="Envio de Reclamo" />
      <div className="page-wrapper my-5">
        <div className="content">
          <div className="container d-flex justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-lg border-0 rounded-4">
                <div className="card-header bg-primary text-white rounded-top-4">
                  <h4 className="mb-0 text-center fw-bold">Envío del Libro de Reclamaciones</h4>
                </div>
                <div className="card-body">
                  <p className="text-muted text-center mb-4">
                    Ingresa un correo electrónico válido para enviar tu hoja de reclamación.
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-4">
                      <TextInput
                        name="email"
                        label="Correo electrónico"
                        value={userEmail}
                        required
                        placeholder="ejemplo@correo.com"
                        onChange={(e) => setUserEmail(e.target.value)}
                      />
                    </div>
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary px-4 py-2 d-flex align-items-center justify-content-center gap-2" disabled={submitting}>
                        <i className="fas fa-paper-plane ms-0"></i>
                        {submitting ? "Enviando..." : "Enviar hoja de reclamación"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SuccessModal
        show={successModalVisible}
        onClose={() => setSuccessModalVisible(false)}
        title="¡Correo enviado exitosamente!"
        text="La hoja de reclamación ha sido enviada al correo proporcionado. Revisa tu bandeja de entrada o spam para confirmar la recepción."
        onConfirm={() => setSuccessModalVisible(false)}
      />

      <ErrorModal
        show={errorModalVisible}
        onClose={() => setErrorModalVisible(false)}
        text={errorMessage}
        footer={(
          <button className="btn btn-danger" onClick={() => setErrorModalVisible(false)}>
            Cerrar
          </button>
        )}
      />
    </>
  );
};

export default ComplaintUserEmail;